﻿import Icon from '../../../components/AppIcon';
import ThreeDotLoading from '../../../components/ui/ThreeDotLoading';
import { mapLeaveType } from '../../../utils/common';

const ApproveLeaveModal = ({
  isOpen,
  onClose,
  onConfirm,
  leave,
  isLoading,
  getStartTimeDisplay,
  getEndTimeDisplay,
}) => {
  if (!isOpen || !leave) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-semibold text-text-primary">Approve Leave Request</h3>
          <button onClick={onClose} className="text-text-secondary hover:text-text-primary">
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="space-y-3 mb-6">
          <div className="bg-secondary-50 rounded-lg p-4">
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div>
                <p className="text-text-secondary">Employee</p>
                <p className="font-medium text-text-primary">
                  {leave?.user?.first_name + ' ' + leave?.user?.last_name}
                </p>
              </div>
              <div>
                <p className="text-text-secondary">Employee ID</p>
                <p className="font-medium text-text-primary">{leave?.user?.employee_id}</p>
              </div>
              <div>
                <p className="text-text-secondary">Leave Type</p>
                <p className="font-medium text-text-primary">{mapLeaveType(leave?.type)}</p>
              </div>
              <div>
                <p className="text-text-secondary">Duration</p>
                <p className="font-medium text-text-primary">{leave?.duration || '-'}</p>
              </div>
              <div className="col-span-2">
                <p className="text-text-secondary">Start Date</p>
                <p className="font-medium text-text-primary">{getStartTimeDisplay(leave)}</p>
              </div>
              <div className="col-span-2">
                <p className="text-text-secondary">End Date</p>
                <p className="font-medium text-text-primary">{getEndTimeDisplay(leave)}</p>
              </div>
              <div className="col-span-2">
                <p className="text-text-secondary">Reason</p>
                <p className="font-medium text-text-primary">
                  {leave?.reason || 'No reason provided'}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 text-text-secondary hover:text-text-primary transition-colors duration-200 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200 disabled:opacity-50 flex items-center space-x-2"
          >
            {isLoading ? (
              <>
                <ThreeDotLoading />
                <span>Approving...</span>
              </>
            ) : (
              <span>Confirm Approve</span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApproveLeaveModal;
